/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AppReview } from 'components/appreview'

// TODO Set the correct article ID here
// const ARTICLE_ID = '27557873'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />

      <AppReview
        title='Komoot'
        icon={require('./images/icon-komoot.jpg')}
        subtitle='Der persönliche Routenplaner'
        audience='Für Wanderer, Läufer und Radfahrer'
        price='Basisversion gratis. Kaufversion bietet zusätzliche Features'
        description={
          '<p>Mit Komoot lassen sich weltweit Touren für Wanderer und Radfahrer planen, suchen und aufzeichnen. Die App bietet Inspirationen für den gemütlichen Wanderer über den sportlichen Läufer bis zum ambitionierten Mountainbiker. Die Routen lassen sich in leicht, mittel und schwer unterteilen und beinhalten teilweise auch Vorschläge für Gaststätten oder Aussichtspunkte. Standard sind Angaben wie Streckenlänge, Höhenmeter, Profil und Navigationsfunktion. Komoot profitiert davon, dass Nutzer ihre Lieblingsrouten speichern und anderen mit möglichst vielen Informationen zur Verfügung stellen. In bevölkerungsreichen Gebieten und Tourismusdestinationen ist die Auswahl an Touren entsprechend grösser als in ländlichen Regionen. <i>(ukä)</i></p>'
        }
        strength='Routenvorschläge mit unterschiedlichen Schwierigkeitsgraden'
        weakness='Eigene Strecken lassen sich via App nur umständlich bearbeiten und abspeichern, besser gehts am PC'
        appStore='https://app.adjust.com/qgth52?adgroup=footer&fallback=https%3A%2F%2Fitunes.apple.com%2Fapp%2Fkomoot%2Fid447374873'
        playStore='https://app.adjust.com/qgth52?adgroup=footer&fallback=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dde.komoot.android%26hl%3Den'
        screenshots={[
          { image: require('./images/komoot1.jpg') },
          { image: require('./images/komoot2.jpg') },
          { image: require('./images/komoot3.jpg') }
        ]}
      />

      <AppReview
        title='Myfitnesspal'
        icon={require('./images/icon-myfitnesspal.jpg')}
        subtitle='Für die perfekte Ernährung'
        audience='Für Leute mit einem klaren Trainingsziel'
        price='Gratis'
        description={
          '<p>Training allein reicht nicht, um Fitnessziele zu erreichen. Die Ernährung spielt ebenfalls eine grosse Rolle. Die App MyFitness-Pal hilft, den Überblick aller Mahlzeiten und Snacks zu bewahren. Sie eignet sich für Leute, die wissen, in welchem Zeitraum sie ein gewisses Gewicht erreichen möchten. Nach Angabe von Start- und Wunschgewicht berechnet die App, wie viele Kalorien pro Tag der Nutzer zu sich nehmen soll. Ebenfalls können verbrannte Kalorien eingetragen werden, was den (Trainings-)Tag besser einordnet. Ein weiterer Vorteil ist, dass bei den meisten Lebensmitteln der Barcode gescannt werden kann – vieles ist in der Datenbank registriert. <i>(fas)</i></p>'
        }
        strength='Die App ist zusätzlich mit dem Schrittzähler des Smartphones synchronisiert, was zu den verbrannten Kalorien hinzugerechnet wird.'
        weakness='Alle persönlichen Angaben sind Schätzwerte. Eine genaue Angabe ist mit einer standardisierten App unmöglich.'
        appStore='https://itunes.apple.com/us/app/myfitnesspal/id341232718?mt=8'
        playStore='https://play.google.com/store/apps/details?id=com.myfitnesspal.android'
        screenshots={[
          { image: require('./images/myfitnesspal1.jpg') },
          { image: require('./images/myfitnesspal2.jpg') },
          { image: require('./images/myfitnesspal3.jpg') },
          { image: require('./images/myfitnesspal4.jpg') }
        ]}
      />

      <AppReview
        title='Seven'
        icon={require('./images/icon-seven.jpg')}
        subtitle='Die beste Kompromisslösung für die eigene Fitness'
        audience='Für Anfänger mit kleinem Zeitbudget'
        price='Gratis, Upgrade für 59 Franken'
        description={
          '<p>Für alle, die einen vollen Terminkalender haben und sich die 1000 Franken fürs Fitnessabo sparen möchten, ist die Trainings-App Seven genau richtig. Das Programm bietet von allem etwas, wenn man seine Ausdauer steigern oder die Muskeln wachsen lassen will – und das in gerade mal sieben Minuten pro Tag. Klar erreicht man so keine Spitzenergebnisse, aber für Menschen mit einer hohen Stressdichte im Alltag ist Seven eine gute Kompromisslösung. Nach der Anmeldung kann der Nutzer zwischen verschiedenen Trainingszielen (abnehmen, fit werden, stark werden) auswählen. Danach gehts bereits los. Alles, was man für die Übungen benötigt, ist das eigene Körpergewicht. Für Sportler, die noch ein bisschen mehr Abwechslung wollen, empfiehlt sich die Trainings-App Freeletics. <i>(tmü)</i></p>'
        }
        strength='Einfach, gratis, gut in den Alltag integrierbar'
        weakness='Oft die gleichen Übungen, sehr rudimentäre Grafik'
        appStore='https://itunes.apple.com/us/app/7-minute-workout-seven-high/id650276551?mt=8&uo=4&at=10l52f&ct=website'
        playStore='http://play.google.com/store/apps/details?id=se.perigee.android.seven'
        screenshots={[
          { image: require('./images/seven1.jpg') },
          { image: require('./images/seven2.jpg') }
        ]}
      />

      <AppReview
        title='Keep Yoga'
        icon={require('./images/icon-keepyoga.jpg')}
        subtitle='Entspannung umsonst'
        audience='Für jeden, ausser absolute Anfänger'
        price='Gratis'
        description={
          '<p>Um bei der Applikation Keep Yoga mit der Yogalehrerin auf dem Bildschirm mithalten zu können, muss man kein Verrenkungskünstler aus dem Cirque du Soleil sein. Doch ein Yoga-Studio sollte man zuvor schon mal von innen gesehen haben. Dennoch bietet die App für jeden etwas, der sich die ultimative Entspannung ins eigene Wohnzimmer holen will – und das auch noch umsonst. Bis zu fünf Trainings kann man in einer Woche durchführen. Eine Yogalehrerin zeigt auf dem Bildschirm die Übungen vor und gibt Tipps. Alles, was man selbst braucht, ist eine Matte, um dem eigenen Rücken etwas Gutes zu tun. Die Workouts dauern zwischen 15 und 20 Minuten und passen so in jeden ausgefüllten Alltag. <i>(tmü)</i></p>'
        }
        strength='Yoga umsonst, einfach und gut erklärte Übungen'
        weakness='Nur in Englisch, Werbung ploppt zwischendurch aus dem Nichts auf'
        appStore='https://apps.apple.com/ch/app/keep-yoga-yoga-meditation/id1395292905'
        playStore='https://play.google.com/store/apps/details?id=com.gotokeep.yoga.intl&hl=en'
        screenshots={[
          { image: require('./images/keepyoga1.jpg') },
          { image: require('./images/keepyoga2.jpg') }
        ]}
      />

      <AppReview
        title='Pillow'
        icon={require('./images/icon-pillow.jpg')}
        subtitle='Der Schlafüberwacher'
        audience='Für die, die mitten in der Nacht hellwach in ihren Apps rumstöbern'
        price='Gratis'
        description={
          '<p>Wer die eigenen Schlafgewohnheiten rudimentär überwachen möchte, der muss keinen Abstecher ins nächste Schlaflabor machen. Pillow bietet die grundlegenden Optionen, um die Erholung in der Nacht zu verbessern. Über den Beschleunigungssensor und das Mikrofon werden jegliche Bewegungen und Töne aufgezeichnet, um so Daten über den Schlaf zu erhalten. Wie lange lag man wach? Wie viele tiefe Schlafphasen durchlief man? All diese Fragen beantwortet die App anhand einer Grafik am Morgen danach. Studien haben gezeigt, dass Apps gerade die Wach-Schlaf-Unterscheidung gut hinbekommen. Die Unterscheidung zwischen den einzelnen Schlafphasen (Tief- und Leichtschlaf sowie REM) funktioniert aber noch lange nicht so wie gewünscht. <i>(tmü)</i></p>'
        }
        strength='Rudimentäre Schlafanalyse, übersichtliche Grafiken'
        weakness='Unterscheidung der unterschiedlichen Schlafzyklen fragwürdig'
        appStore='https://itunes.apple.com/app/pillow-sleep-cycle-alarm-clock/id878691772'
        screenshots={[
          { image: require('./images/pillow1.jpg') },
          { image: require('./images/pillow2.jpg') }
        ]}
      />

      <AppReview
        title='Garmin Golf'
        icon={require('./images/icon-garmingolf.jpg')}
        subtitle='Für Hobbygolfer, die Distanzen und noch viel mehr wissen wollen'
        audience='Für Golffanatiker, die mehr als nur die Scorekarte auswerten wollen'
        price='Gratis'
        description={
          '<p>Geräte, die mittels GPS jedem Spieler stets mitteilen, wie weit es noch bis zur Fahne oder zum nächsten Wasser- oder Sandhindernis ist, sind aus der Golfwelt nicht mehr wegzudenken. Die Uhren der neueren Generation können aber noch viel mehr: Sie realisieren beispielsweise auch, wann ein Schlag ausgeführt wird, und speichern die Distanzen. Im Zusammenspiel mit einer App – in diesem Fall Garmin Connect – lassen sich diese Daten nach der Runde per Bluetooth aufs Handy laden, und zwar direkt auf das Layout des gespielten Golfplatzes. So lässt sich die Runde später, fast Schlag für Schlag, grafisch aufbereitet nachverfolgen und herausfinden, mit welchem Schlag welche Distanz erreicht wurde. Je mehr Runden erfasst wurden, desto spannender und aufschlussreicher sind die generierten Statistiken. <i>(rst)</i></p>'
        }
        strength='Gute Grafik, international einsetzbar, genau'
        weakness='Gelegentliche Verbindungsprobleme'
        appStore='https://itunes.apple.com/us/app/garmin-golf/id1192480582?'
        playStore='https://play.google.com/store/apps/details?id=com.garmin.android.apps.golf'
        screenshots={[
          { image: require('./images/garmingolf1.jpg') },
          { image: require('./images/garmingolf2.jpg') }
        ]}
      />

      <AppReview
        title='Activity für Apple Watch'
        icon={require('./images/icon-appleactivity.jpg')}
        subtitle='Für Hobbysportler und Faulenzer, die sich etwas mehr bewegen wollen'
        audience='Für alle, ganz besonders aber für Sportverweigerer mit einem iPhone'
        price='Gratis für Apple Watch'
        description={
          '<p>Die Apple Watch ist der Tausendsassa unter den smarten Armbändern. Abgesehen von den vielen anderen Funktionen wie Apps, Telefonie oder Notruf bei Stürzen gefällt sie auch als Fitnessuhr. Auch wenn manche Profis damit Marathons laufen, eignet sie sich gerade für notorische Faulenzer. Die Fitness-App ist äusserst übersichtlich und intuitiv, drei bunte Ringe wollen täglich geschlossen werden. Einer steht für Bewegen, einer für Training und einer für Stehen. Hat man seine Tagesziele erfüllt, gibt es Auszeichnungen. Wer sich davon nicht motivieren lässt, lässt sich vielleicht von den sogenannten Fitnessduellen anspornen. Wenn man Freunde mit einer Apple Watch hat, kann man diese zum Duell herausfordern. Während einer Woche wird dann täglich abgeglichen, wer seine Tagesziele besser erfüllt hat. <i>(zei)</i></p>'
        }
        strength='Kann dank anderen, zusätzlichen Apps fast alles'
        weakness='Akku hält nur einen Tag'
        appStore='https://apps.apple.com/us/app/activity/id1208224953#?platform=appleWatch'
        screenshots={[
          { image: require('./images/appleactivity3.jpg') },
          { image: require('./images/appleactivity2.jpg') },
          { image: require('./images/appleactivity1.jpg') }
        ]}
      />

      <AppReview
        title='Strava'
        icon={require('./images/icon-strava.jpg')}
        subtitle='Wie Facebook, aber für Sportler'
        audience='Für Profisportler und solche, die es noch werden wollen'
        price='Gratis'
        description={
          '<p>Die Kurzerklärung für Uneingeweihte geht so: Strava, das ist Facebook für Sportler – aber ohne Katzenvideos und Weltverschwörungstheorien. Auf Strava laden Hobby- und Profisportler ihre mit GPS-Uhr oder Handy aufgezeichneten Trainings hoch. So sehen ihre Follower, wie und wo sie zuletzt geschwitzt haben, können sie dafür loben und kommentieren. Das mag sich oberflächlich anhören, ist aber tatsächlich motivierend. Genauso wie die virtuellen Strecken, für die Strava unter allen Sportlerinnen automatisch Ranglisten erstellt, die diese schon einmal absolviert haben. Das animiert, auch mal auf der Joggingrunde im Quartier die Komfortzone zu verlassen. <i>(ebi)</i></p>'
        }
        strength='Motiviert langfristig'
        weakness='Ein Messenger zum Austausch unter den Sportlern fehlt'
        appStore='https://itunes.apple.com/app/strava-cycling/id426826309?mt=8'
        playStore='https://play.google.com/store/apps/details?id=com.strava'
        screenshots={[
          { image: require('./images/strava1.jpg') },
          { image: require('./images/strava2.jpg') }
        ]}
      />

      <AppReview
        title='Gyroscope'
        icon={require('./images/icon-gyroscope.jpg')}
        subtitle='Der fleissige Datensammler'
        audience='Für polysportive Datensammler'
        price='79 Franken pro Jahr'
        description={
          '<p>Die Liste hier zeigt es: Es gibt Apps für jede Sportart. Bloss, was bringen all diese Daten, wenn sie in einzelnen Apps verstreut sind und nicht in einen Zusammenhang gesetzt werden? Gyroscope will das beheben. Indem Daten aus verschiedensten Apps zusammengezogen werden, sollen neue Erkenntnisse möglich sein. Als Grundlage dienen die Daten aus Apple Health oder Google Fit, ergänzt mit Fitbit, Strava und Garmin. Die App versucht, all diese Daten zu kombinieren und auf einen Gesundheitswert herunterzubrechen, mit konkreten Vorschlägen, wie dieser verbessert werden kann. Gute Noten gibt es für regelmässiges Training und regelmässige Meditation; Abzüge, wenn man nicht genügend schläft oder sich während des Tages zu selten bewegt. <i>(xeo)</i></p>'
        }
        strength='Am Ende des Jahres gibt es eine schön gestaltete Chronik mit der persönlichen Sportleistung'
        weakness='Unübersichtlichkeit aufgrund verschiedener Interfaces. Ausserdem landen sehr viele persönliche Daten auf einem fremden Server'
        appStore='https://itunes.apple.com/app/apple-store/id1104085053?pt=117927205&ct=website&mt=8'
        playStore='https://play.google.com/store/apps/details?id=com.gyroscope.gyroscope'
        screenshots={[
          { image: require('./images/gyroscope1.jpg') },
          { image: require('./images/gyroscope2.jpg') },
          { image: require('./images/gyroscope3.jpg') },
          { image: require('./images/gyroscope4.jpg') },
          { image: require('./images/gyroscope5.jpg') }
        ]}
      />

      <AppReview
        title='Wetter-Apps'
        icon={require('./images/icon-wetter.jpg')}
        subtitle='Die wichtigste Applikation hat nichts mit Sport zu tun'
        audience='Für Sportler, die trocken bleiben wollen'
        price='Gratis bis 7.50 Franken'
        description={
          '<p>Die vielen Trainings-Apps sind ja eine tolle Sache. Aber auch gefährlich: Sie halten vom Sinn der Sache ab – dem Training. Diese Gefahr besteht bei der – unserer Ansicht nach – wichtigsten App nicht: der Wetterdienst-App. Bevor es nach draussen geht, ist nicht die neuste Übung und die tollste Strecke entscheidend, sondern ob es eine Jacke braucht, Handschuhe und Kappe – oder doch die Sonnenbrille. Dafür konsultieren wir die Meteo-App unseres Vertrauens. Weil es mit den Prognosen so eine Sache ist, vergleichen wir meist die Vorhersagen mehrerer Anbieter und vertrauen dann der optimistischsten. Optionen hierbei sind die Applikationen <a href="https://itunes.apple.com/ch/app/meteoswiss/id589772015?l=de&amp;ls=1&amp;mt=8" target="_blank" rel="noopener noreferrer">Meteo Swiss</a> (gratis), <a href="https://apps.apple.com/ch/app/landi-wetter/id363411690" target="_blank" rel="noopener noreferrer">Landi Wetter</a> (gratis) oder <a href="https://itunes.apple.com/ch/app/pflotsh-storm/id1320763970?mt=8#" target="_blank" rel="noopener noreferrer">Pflotsh Storm</a> (Jahresabo 7.50 Franken). <i>(ebi)</i></p>'
        }
        strength='Alle sind auf den spezifischen Ort anpassbar'
        weakness='Manchmal regnet es, obwohl die App trockene Strassen verspricht'
        screenshots={[
          { image: require('./images/wetter1.jpg') },
          { image: require('./images/wetter2.jpg') },
          { image: require('./images/wetter3.jpg') }
        ]}
      />
    </div>
  )
}
